/* istanbul ignore file */
import * as React from 'react';
import {ProvidedGlobalProps, withGlobalProps} from '../../providers/globalPropsProvider';
import s from './ViewMore.scss';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {compose} from '../../../commons/utils';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../specs';

export const ViewMoreDataHook = 'quick-view-more';

function ViewMoreComponent({
  t,
  globals: {isPreviewMode, navigate, product, productUrl},
}: ProvidedGlobalProps & IProvidedTranslationProps) {
  const {experiments} = useExperiments();
  const shouldNavigateUsingHref =
    experiments.enabled(SPECS.FixQuickViewNavigationToProductPage) &&
    (!isPreviewMode || !experiments.enabled(SPECS.FixQuickViewNavigationToProductPageInPreviewMode));
  const hrefProps = shouldNavigateUsingHref
    ? {
        href: productUrl,
        target: '_top',
      }
    : {
        href: product.urlPart,
        onClick: (e: React.MouseEvent<HTMLAnchorElement>) => {
          e.preventDefault();
          navigate(product.urlPart, true);
        },
      };
  return (
    <a data-hook={ViewMoreDataHook} className={s.root} {...hrefProps}>
      {t('productPage.quickView.viewProductDetails')}
    </a>
  );
}

export const ViewMore = compose(withTranslations('globals.texts'), withGlobalProps)(ViewMoreComponent);
